<template>
  <div id="material">
    <h1>material</h1>
    <p>{{msg}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "我是material 组件"
    };
  }
};
</script>
